/** Image URLs from LUXE UGC sample HTML (placeholders). */
export const BRAND_SAMPLE_IMAGES = {
    headerAvatar:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuAHhAn7JtYbgbBhx_QvP1FOnX-Xd-UgqewGFecEtxibJEGxhnM4YBmjMpsTt9i0vz1xW3p3BMoyT_W-W2_f3If2FMYMSoMoKAe9p_6htaKzCmf953FnPieXDS37UoE6KGcQAkyYILQgvM0LNU8NM1a3VbyO9uv4tHmjpjohry6gbUjlfk8kkH04RLRZyimjremu0xKZr8gfyYYsST3B6YvptnftfKmP181j5VvqYxkvVYrUOFjENFB-lQhpt7lkwsME0Izpg9YYpA',
    campaignSummer:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuAlc8fvXMT9CzahlKXJ6rm1fo40UGp45R4SfgBBTJf3Dow3-_VpjaX8RdP78eOvyHZPJiyrZUJpD3hTJyYJsHDHOX9d6Q2PemfJYIyzG7H4Hf_RYfmRtzh9m8V7Ot0BQ3dAdCvVTHHz5N32oYdkiNQdykKkTOGycPR7-AjNreHNBwDD9BpLDZ_OB8kSBE8N7sfX2FiCFtffZoKktt0uMxWIMIYBKjJ8EgbJMhlZi9gJY4X6xTp0mB7JulhVmMjPwFiIK0M9s5eDOg',
    campaignTech:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuD84Q3WxguL-ND2oJt6r3GWdE_HBmSJg6bwyJ_5x6NMyOc9mD0WCOl9bJjmtrTLkLlcPRlVA54GAu067tj8u-ob3xfHeHbiDEzQJyHPt5eQxWVOUmJm62KfgDHM_UBr8Z8WdfA_1kcaL3GdXY-hnif3b1-olPLI3y2kDrCz-BRS3lhPPs_NZdwA8SUSNvGdAq-vTYu4JDbKkgE3zAVHm7ji_9jDPudc6-AlW98sgmDe1bffv4e9lKM4Iq7Z4R2c8Q-fB8DvHjUbcw',
    pendingAvatar1:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuCOKgu3aUvo_66FYUSGzPE1xCErxY3-3P-0MapJpaDDsrjY_2XmPZqn2lP8uqyEZAR61P92FZdlsflogauTh6j1tqiw12mJ4Pp1O-QtXWz1QQc0_CvS248Jfdy9Onnv5lmo4Kmf81l5XC-O4eAdCG-X-8Ea94vzJc-48zkX3-lJ72s2GXgznZvq_wOneI5kcfcSk0jojN_FyUseDtfCdgyiK9f3gnx-UMU9pKl5WexWQu0047dstwhvEOLsoAx95lmrBhNqIZ6lbg',
    pendingAvatar2:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuAkhVweSefNHkLyC-sOFZyo9BbC2wuy3FAUKWLubb_zqYyqYa9wN7k0X0LrQVVuFOS1L60btrB1BeU8AB1DzXNMhC_GCmvDx2l3l5388UqE1k7BfDYYdAbhwmyKDR3ycfmtoc3RaygfMt6-7Sr4n-b0H67sWQUMQhzo1KJrCb65WWb1pyelKvCN516DqQeHxcStd_1scnF47TjGpne7L947-vdxO_m2MffblUcvbI5FCAG5EbSjKOcqEfhaRH9LNRhDM6_-vPeFdQ',
} as const;

/** NEON CURATOR find-talent sample (mobile search UI). */
export const NEON_CURATOR_HEADER_AVATAR =
    'https://lh3.googleusercontent.com/aida-public/AB6AXuAVxcOdVxtTPeoN3c1BdOphF_Zbj3C-oqj9t-o-kTp9Yly2vpRkci1f-tj63BixPl-zh3vPwMh9pez7x2gNUrqGhoktgCQlct0rotSQxZxDSeWXGwQABckhe8EKRsPRjVs2kSyEngPaP5QKXZbr1gCio-9Bw8Qe5lddBYVWDAM6uXhHOvXD0ybhjFQ9CBivGZQkjPChOJFg8a6zkBna7KZOlUaLBM2FWLrDCzvP2nTU7dabN-XmKgM2RkBH-T_7GxJhQsxIgaSVxQ';

export const NEON_CREATOR_CARDS = [
    {
        id: '1',
        name: 'Luna Sterling',
        category: 'Lifestyle & Fashion',
        followers: '842K',
        engagement: '4.8%',
        location: 'NYC',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAU-uswTp42FDOc7sz-rq3b7cPAE9LuyAswx1g4TqN819hRMBNiNcifjvFxLgzxw44z6eZAkkua1u45OJK4ZEpzIJOtlc1i1PB8Z4wxhsXhw5nHtRwyTyAGo8IRP7CzvNp0mw2Bxp-LT9AFJH5gUBsfhRYV45GtDYPogK1ZEnr7SHZzBqXdbxa4tm54fl9KXmSK1xj_pvl9noM8S8KqGq2co0vHBn_jLqyoaqpW2Q-IU3ni3leTARC_8wGyZsBGA2XEsRQx6g1dSQ',
        badge: { label: 'Live now', tone: 'secondary' as const },
    },
    {
        id: '2',
        name: 'Marcus Vane',
        category: 'Tech & Productivity',
        followers: '1.2M',
        engagement: '6.2%',
        location: 'London',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBCZsV4UvFtFemzda3tCNl5w_PWFXY9ACp0xbLXxEcRDn4TLVW2FkMba7u2kb1vWlXsPl2OIjtxXjjM5nEQyb6ZIAccEyrLdwnY6s3koaTirypXHYv_yeULg0glqJQCl1iabOXbY2-IOZ204mVyhWR9tKoJF8VUGiwazMVmxMI6Peil8uExMDCxe7d2d8JbARcDUGomsl_rsG7nP8X4B1vP9A5ckees5AJmfKsBWRwpDBNt9RuDmjr_CjVv7hqObCnlSZpG6Y43vw',
        badge: { label: 'Top choice', tone: 'primary' as const },
    },
    {
        id: '3',
        name: 'Elena Rossi',
        category: 'Travel & Wellness',
        followers: '450K',
        engagement: '8.1%',
        location: 'Milan',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBLxl-4c8AOmEp2mp4KFujhswAGIwfalxICCxHvMW_yMq-nwWptjEBg33YnzvQ06oqDuOfhh0xbpb1rowC7MpPz3brPs0kM_QSRC4rHIEapDR5s8oYQ_-4Wb3pYFgPSmuXF4aRmSB51YsDSd1aUqwxn8onfLl2eGjjeuHgfF2Febf6CPaK5ryz2sayYO5lVRIynWW1VNZvfj2zGL1gxzzKqHVYaksAhmbC0iSciTjcVu5jvFtJ6tenZ4e7Edmp-JNYewItwdnhHqA',
        badge: undefined,
    },
] as const;

/** Midnight campaign creator — curated creators sidebar (sample HTML). */
export const CAMPAIGN_CURATED_CREATORS = [
    {
        id: 'cc1',
        name: 'Marcus Chen',
        meta: 'Tech & Lifestyle • 840k',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBHGu6A-lGMt1-XOikZal24ZKY_f2jMq9z73QqimujNpCGIfSp6pHrj4LSUw56ArWKMFM8mqStoXn9JtruQ6G8V1ojKu5fO2Aiu4MSuAOMaxf_0AdkOM5Yiggp0bUt9GkdyzxPZnPCxN_lwtBIKIxsCKjeWAW0ffih3MBwjSlqxjTCBkUO3BKoNW6gxuh_ojnrf-6JznL9uVDVof9xV-e_MVJ1rsysD0aGH7mlYDAB3coTIPCgdP0Bz9ut0R9N0HowFJwm31HMCRA',
        defaultInvited: false,
    },
    {
        id: 'cc2',
        name: 'Sasha Bloom',
        meta: 'Acting & Creative • 1.2M',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBuEufPJphaDBvZMJQ0CU2JeHWLiWcS9qRS8SR3ZxBPTFgd26nkqbfBwppnFsXwCrhxUlwJ7nwx83KttOympS7QqdVBZghQq0ibxlcYjoOG_RgLavAtpveL2xmKCnX7686StZBbHahOYeuW3Owc8JlFGwVmySQHzJ51i9TQjkc5-vCYrf-6qjo8cIIuOm2jK-Nnt-Xqh1EM6BuEOkmleaELl7ofk0hvP-O8Rw3GvQch7soKQwwRGMnpR9CGLmBaSqt6uXrlCuwBLw',
        defaultInvited: false,
    },
    {
        id: 'cc3',
        name: 'David Thorne',
        meta: 'Wellness & Tech • 450k',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDUibpSe87lQ4WTyrpePshYfvB7f_DUpumm2PMD6fYC3Wyo8WVPyKiZ8KJCg24xQAN6-hM2wMBskZQ2zM4biyDKZHUx4cb4nEOcUtUxjd-tUECLFyBkEtjoF0MPCh2ue-Sf3xir7e7Cq8Jk-2UdLQ73xon_iQzJsu8SaxnH2iieyfBmZWCVN5rknDu7uK4sUNcDu4ojwAYN9LjKwQicwMCMiZPmRGPBJzxQACSXOCemBGe58OjW_MqjcqGUKC49JBxWAWLHBGB6w',
        defaultInvited: false,
    },
    {
        id: 'cc4',
        name: 'Elena Vance',
        meta: 'Luxury Lifestyle • 2.1M',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD3aGK-wzfQMbSET4zd43AGtNsaoibWQCXOFoLJTVSQaZg58lslxxPHc9_pd5OqquGAV55nDtKsZ76_t4LdEEF4QcaBlO9N2GSH-OAice76aFaF3DFmVqnNYP8TQ6rpfGJtHPGlXj6gtZlXUAy_SW_R8usBlQZUVEBrWKH2RBQHqGPsDMSyleWjxuIymt_yFKUGOIFGASAOa5Q4K4JMs5QF5aRQCH7bsLuX3NpXrFwQo3iMUi-RsUi01N0yrQ0cPezv7bwn6oK1mQ',
        defaultInvited: true,
    },
    {
        id: 'cc5',
        name: 'Julian K.',
        meta: 'Tech Reviews • 310k',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC4z37ZgwOct7E11bvtT_ScmNBxCHrPGAJdQSlDxERn4QxfwP-SK31s3TVcwfco60292csgFQF-q7vB_aOiT8Njh6u2EjQQTcpTZGjlE-rERjA-UzCv_KV6m2BpW6anxc58KLxSjLZKvQXPIve8OObxNmGlqwFN6lRJrjZmoOUV6Z0Q5zAEEmWcUo7jNgxvcRyCXILcPDHVedfDYg70HF6wnmc08qgBLsaxWTuZ_TdJPUAJTej0MKPWTBxxFDGzedrDvdKb3y2UfGw',
        defaultInvited: false,
    },
    {
        id: 'cc6',
        name: 'Mia Rossi',
        meta: 'Acting • 670k',
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDHpYjUNm7rvtrJrT8DJtGb-HEHxgkblPB9o9Gq4FnGT27xne-JDGcfqBMYzw1RcDSNAQiXWrneFQT2PVMHTNGs1mrDFRNZOgpbNbDTAexV__bsM-ZMPp1uX8W71dwNXF7uwN2mhQC0fyrGr2cERbugpHPmiZihKoDtvnCy3SK4osWCVeT3ZQbabRpB4eFCGKP7c2FFNr1A_cPTpL6EDMi6ynoo9M6zAXosAA19v8pCrAkDm7W7xXXV3OVx7aakBgHKT1LxHy_v8A',
        defaultInvited: false,
    },
] as const;
